<div class="container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          [disabled]="true"
          formControlName="usageToken"
          label="Copy & paste this into Shopify's components by 'Discount Rejection Coupon token'"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">General</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          label="Internal name"
          formControlName="internalName"
          [invalid]="formGroup.get('internalName')?.touched && formGroup.get('internalName')?.hasError('required')"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input
          label="Internal description"
          formControlName="internalDescription"
          placeholder="Coupon code rejection"></pdq-input>
      </div>
    </div>
  </pdq-card>
</div>
